import type { ReactElement } from 'react';
import { useState } from 'react';
import { ConfirmDialog } from '../../components';
import { useRemoveInstaller } from './graphql';

interface Props {
  refetch: () => Promise<unknown>;
  onClose: () => void;
  installerId?: string;
}

export const DeleteInstaller = ({ refetch, installerId, onClose }: Props): ReactElement => {
  const [loading, setLoading] = useState(false);
  const [mutation] = useRemoveInstaller();

  const handleConfirm = (): void => {
    if (installerId === undefined || loading) {
      return;
    }

    void (async (): Promise<void> => {
      setLoading(true);
      await mutation(installerId);
      await refetch();
      setLoading(false);
      onClose();
    })();
  };

  return (
    <ConfirmDialog
      open
      tone='danger'
      title='Remove this installer?'
      message='The file will remain in cloud storage.'
      confirmLabel={loading ? 'Removing…' : 'Delete'}
      onConfirm={handleConfirm}
      onCancel={onClose}
    />
  );
};
